import { useMemo } from 'react';

import { IntegrationServices } from '@/modules/common/types/integrations';
import { useIntegrationStatus } from '@/modules/onboarding/integrations-setup/hooks/use-integration-status';

/**
 * Hook to check if QuickBooks integration is connected
 * @returns boolean indicating if QuickBooks is in the list of integrations
 */
export const useQuickBooksConnection = () => {
  const { data: integrationStatusData } = useIntegrationStatus({ enablePolling: false });

  const isQuickBooksConnected = useMemo(() => {
    if (!integrationStatusData) {
      return false;
    }

    return integrationStatusData.integrations.some(
      integration => integration.integration === IntegrationServices.QUICKBOOKS
    );
  }, [integrationStatusData]);

  return {
    isQuickBooksConnected,
    isLoading: !integrationStatusData,
  };
};
